<template>
	<section class="view-feed-item">
		<slot name="header"></slot>

		<section class="body">
			<slot name="body"></slot>
		</section>

		<footer>
			<slot name="footer"></slot>
		</footer>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedItem extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.view-feed-item {
		background-color: var(--chalky-blue-3); // these will change by nth-child
		position: relative;

		.view-layout-moduleheader {
			margin-bottom: 0;
			padding: var(--padding);
		}

		.body {
			height: 100%;
			overflow: hidden;
			position: relative;
		}
	}
</style>
